var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { I18NLink } from "../../../I18N";
import { Icon } from "../../../UI";

import api from "../../../Search/SearchAPI";

const processesIds = ['58b2f3a35d59f31e1345b48a'];
const provisionalMeasuresIds = ['58b2f3a35d59f31e1345b4a4'];
const documentsIds = [
'58b2f3a35d59f31e1345b4ac',
'58b2f3a35d59f31e1345b471',
'58b2f3a35d59f31e1345b482',
'58b2f3a35d59f31e1345b479'];


export class cejilChart001 extends Component {
  getData() {
    api.search({ limit: 0 }).then((results) => {
      this.setState({ data: results.aggregations.all });
    });
  }

  conformLibraryLink(types, link) {
    const escapedValues = types.map((t) => `%27${t}%27`);
    if (link && link.indexOf('/library/') !== -1) {
      return link.substring(link.indexOf('/library/'), link.length);
    }
    return `/library/?q=(order:desc,sort:creationDate,types:!(${escapedValues.join(
      ','
    )}),userSelectedSorting:!t)`;
  }

  getCount(ids) {
    return ids.reduce((count, id) => {
      const bucket = this.state.data.types.buckets.find((b) => b.key === id);
      return count + (bucket ? bucket.filtered.doc_count : 0);
    }, 0);
  }

  componentDidMount() {
    this.getData();
  }

  render() {
    const { title = '', buttons = [], links = [] } = this.props;
    const Loader = /*#__PURE__*/_jsx(Icon, { icon: "spinner", pulse: true, fixedWidth: true });

    let processesCount = Loader;
    let provisionalMeasuresCount = Loader;
    let documentsCount = Loader;

    if (this.state && this.state.data) {
      processesCount = this.getCount(processesIds);
      provisionalMeasuresCount = this.getCount(provisionalMeasuresIds);
      documentsCount = this.getCount(documentsIds);
    }

    return (/*#__PURE__*/
      _jsx("div", { className: "hero" }, void 0, /*#__PURE__*/
      _jsx("h1", {}, void 0, title), /*#__PURE__*/
      _jsx("div", { className: "hero-stats" }, void 0, /*#__PURE__*/
      _jsx(I18NLink, {
        to: this.conformLibraryLink(processesIds, links.length && links[0] ? links[0] : null) }, void 0, /*#__PURE__*/

      _jsx("h2", {}, void 0, processesCount), /*#__PURE__*/
      _jsx("span", {}, void 0, buttons[0])
      ), /*#__PURE__*/
      _jsx(I18NLink, {
        to: this.conformLibraryLink(
          provisionalMeasuresIds,
          links.length && links[1] ? links[1] : null
        ) }, void 0, /*#__PURE__*/

      _jsx("h2", {}, void 0, provisionalMeasuresCount), /*#__PURE__*/
      _jsx("span", {}, void 0, buttons[1])
      ), /*#__PURE__*/
      _jsx(I18NLink, {
        to: this.conformLibraryLink(documentsIds, links.length && links[2] ? links[2] : null) }, void 0, /*#__PURE__*/

      _jsx("h2", {}, void 0, documentsCount), /*#__PURE__*/
      _jsx("span", {}, void 0, buttons[2])
      )
      )
      ));

  }
}








export function mapStateToProps({ templates, thesauris }) {
  return { templates, thesauris };
}

export default connect(mapStateToProps)(cejilChart001);